var React = require('react');
var PropTypes = require('prop-types');
require('./AllFarmTabCoachmark.css');

/**
 * Coachmark tooltip anchored to the "Farm View" (All Farm) header tab.
 * Positioned via DOM measurements of the anchor element.
 */
var AllFarmTabCoachmark = function (props) {
  var anchorRef = props.anchorRef;
  var message =
    props.message ||
    ((props.title || '') + (props.body ? ' ' + props.body : '')).trim();

  var state = React.useState({ top: 0, left: 0, isReady: false });
  var position = state[0];
  var setPosition = state[1];

  var coachmarkRef = React.useRef(null);

  var updatePosition = React.useCallback(
    function () {
      // Primary: position relative to the All Farm tab (anchor).
      if (anchorRef && anchorRef.current) {
        var rect = anchorRef.current.getBoundingClientRect();
        var left = rect.left + rect.width / 2;
        var top = rect.bottom + 10;
        setPosition({ top: top, left: left, isReady: true });
        return;
      }

      // Fallback (mainly for testing / force mode): show centered under header
      // even if the tab isn't rendered (e.g. small viewport).
      var fallbackLeft =
        window && window.innerWidth ? window.innerWidth / 2 : 0;
      var fallbackTop = 58;
      setPosition({ top: fallbackTop, left: fallbackLeft, isReady: true });
    },
    [anchorRef],
  );

  React.useEffect(
    function () {
      updatePosition();

      window.addEventListener('resize', updatePosition);
      window.addEventListener('scroll', updatePosition, true);

      return function () {
        window.removeEventListener('resize', updatePosition);
        window.removeEventListener('scroll', updatePosition, true);
      };
    },
    [updatePosition],
  );

  React.useEffect(
    function () {
      if (!props.isOpen) {
        return;
      }

      var onKeyDown = function (e) {
        if (e && e.key === 'Escape') {
          props.onDismiss();
        }
      };

      var onMouseDown = function (e) {
        // Dismiss on any click outside the coachmark.
        if (
          e &&
          e.target &&
          coachmarkRef.current &&
          coachmarkRef.current.contains(e.target)
        ) {
          return;
        }
        props.onDismiss();
      };

      document.addEventListener('keydown', onKeyDown);
      document.addEventListener('mousedown', onMouseDown);

      return function () {
        document.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('mousedown', onMouseDown);
      };
    },
    [props.isOpen, props.onDismiss],
  );

  if (!props.isOpen || !position.isReady) {
    return null;
  }

  return (
    <div
      ref={coachmarkRef}
      className='all-farm-tab-coachmark-tooltip'
      style={{ top: position.top + 'px', left: position.left + 'px' }}
      role='dialog'
      aria-live='polite'
    >
      <div className='all-farm-tab-coachmark-tooltip__pointer'>
        <div className='all-farm-tab-coachmark-tooltip__triangle' />
        <div className='all-farm-tab-coachmark-tooltip__concealer' />
      </div>

      <div className='all-farm-tab-coachmark-tooltip__body'>
        <div className='all-farm-tab-coachmark-tooltip__message-container'>
          <div className='text-style-short-lables-16-semi-bold all-farm-tab-coachmark-tooltip__message-text'>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

AllFarmTabCoachmark.propTypes = {
  anchorRef: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  // Preferred API: pass a single message.
  message: PropTypes.string,
  // Backwards-compatible API:
  title: PropTypes.string,
  body: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
};

module.exports = AllFarmTabCoachmark;
